import { checkAccessToSuperset } from './role-utils'
import { type User } from './types/user'

interface MenuTab {
  item: string
  options?: string[]
  shouldShowOnHeader: boolean
}

export function addSupersetTab(tabs: MenuTab[], user: User | null): MenuTab[] {
  if (
    !checkAccessToSuperset(user) ||
    tabs.some(
      tab => tab.item === 'superset' || tab.options?.includes('superset'),
    )
  ) {
    return tabs
  }

  const analyticsTabIndex = tabs.findIndex(tab => tab.item === 'analytics')

  if (analyticsTabIndex === -1) {
    return [...tabs, { item: 'superset', shouldShowOnHeader: true }]
  }

  return tabs.map((tab, index) => {
    if (index !== analyticsTabIndex) return tab

    return {
      ...tab,
      options: [...(tab.options ?? []), 'superset'],
    }
  })
}
